<template>
  <div class="patient-list">
    <div class="listWarpper">
      <el-card class="box-card">
        <div slot="header" class="box-card-header clearfix">
          <div class="searchBox">
            <div class="searchInput mainItem">
              <el-input
                v-model="name"
                placeholder="请输入患者姓名"
                @keyup.native="nameChange"
              ></el-input>
            </div>
            <div class="searchInput mainItem">
              <el-button type="text" @click="empty">清空条件</el-button>
              <el-button class="searchInput_btn" type="primary" @click="search"
                >搜索</el-button
              >
            </div>
          </div>
        </div>
        <div class="main">
          <div class="content">
            <el-table
              :data="list_data"
              @sort-change="sortChange"
              class="content-table"
              style="width: 100%"
            >
              <el-table-column
                align="center"
                label="操作人"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <div slot="reference" class="name-wrapper">
                    <p>
                      {{ scope.row.operator }}
                    </p>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                label="订单编号"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.row.orderTreatNumber }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="患者姓名"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">{{ scope.row.memberName }}</div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="审核状态"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.row.checkStatus_dictText }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="申请退费时间"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.row.createTime }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                label="操作"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <!-- <el-button
                    size="mini"
                    v-show="scope.row.is_eye_department == 1"
                    @click="handleCheck(scope.$index, scope.row)"
                    >阅片</el-button
                  > -->


                  <!-- <el-button
                    class="operat-button"
                    type="success"
                    size="mini"
                    v-if="scope.row.checkStatus == 0"
                    @click="onMoneyBack(scope.row.id)"
                    >撤销申请</el-button
                  > -->
                  <el-button
                    class="operat-button"
                    size="mini"
                    type="danger"
                    @click="handleDetail(scope.$index, scope.row, scope)"
                    >查看详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="pageWarpper" v-show="list_data != ''">
          <el-pagination
            @current-change="currentPageChange"
            :page-size="pageList.size"
            :current-page="pageList.current"
            layout="total, prev, pager, next"
            :total="pageList.total"
          ></el-pagination>
        </div>
      </el-card>
    </div>
    <el-dialog
      class="assess-dialog"
      title="退费详情"
      :visible.sync="dialogVisible"
      :center="false"
    >
      <div class="assess-dialog-userInfo">
        <div class="dialog-span">
          <span class="dialog-span-header dialog-span-header-two"
            >患者名称:</span
          >
          <span class="dialog-span-main"> {{ commentInfo.memberName }}</span>
        </div>
        <div class="dialog-span">
          <span class="dialog-span-header">订单编号:</span>
          <span class="dialog-span-main">
            {{ commentInfo.orderTreatNumber }}</span
          >
        </div>
        <div class="dialog-span">
          <span class="dialog-span-header">审核状态:</span>
          <span class="dialog-span-main">{{
            commentInfo.checkStatus_dictText
          }}</span>
        </div>
      </div>
      <div class="dialog-span">
        <span class="dialog-span-header"> 审核原因:</span>
        <span class="dialog-span-main">{{ commentInfo.refuseCause || '无' }}</span>
      </div>
      <div class="dialog-span-two">
        <span class="dialog-span-header"> 退费原因:</span>
        <span class="dialog-span-main">{{ commentInfo.refundCause || '无' }}</span>
      </div>
      <div class="dialog-span-two">
        <span class="dialog-span-header">附件:</span>
        <div class="dialog-span-main demo-image__preview">
          <el-image
            class="annex-img"
            v-for="(item, index) in commentImgArr"
            :src="item"
            :preview-src-list="commentImgArr"
            :key="index"
            :z-index="z_index"
          >
          </el-image>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from "@/utils";
import { getMoneBackList, undoMoneBack } from "@/api/index.js";
import axios from "axios";
import moneyBackPopup from "@/components/moneyBackPopup/index.vue";

export default {
  name: "Patients",
  data() {
    return {
      // 查看评价的数据
      dialogVisible: false,
      imgList: [],
      z_index: 3000,
      defaultHeadImage: require("@/assets/images/default-avatar-patient.png"),

      commentInfo: {},
      tableData: [],
      pageList: {
        pageSize: 10,
        pageNo: 1,
      },
      tabName: "",

      status: "",
      name: "",
      list_data: [],
    };
  },
  components: { moneyBackPopup },

  methods: {
    //撤销退费
    onMoneyBack(id) {
      this.$confirm("是否要撤销退费申请?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        undoMoneBack({ id }).then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          }
        });
      });
    },
    // 查看评价附件的放大事件
    enlargeImg(index) {
      console.log(index);
    },
    empty() {
      this.status = "";
      this.name = "";
      this.pageList.pageNo = 1;
      this.readyPatientList();
    },
    search() {
      console.log("name", name);
      this.pageList.pageNo = 1;
      this.readyPatientList();
    },
    //分页
    currentPageChange(page) {
      this.pageList.pageNo = page;
      this.readyPatientList();
    },

    //查看详情
    handleDetail(index, row, scope) {
      this.commentInfo = row;

      this.dialogVisible = true;
    },
    sortChange(column, prop, order) {
      console.log("val:", column, prop, order);
    },
    //下拉列表选项改变
    optChange(val) {
      // var tabNum = this.$route.query.tabNum;
      // console.log(tabNum);
      // if (tabNum == "2") {
      //   this.readyPatientList();
      // } else if (tabNum == "3") {
      //   this.readyApointList();
      // }
      this.readyPatientList();
    },
    //关键字输入框离开事件
    nameChange() {
      console.log("name: ", this.name);
    },
    /**
     * 初次获取我的退费列表
     */
    async readyPatientList() {
      try {
        const that = this;
        let params = {
          status: that.status,
          pageNo: that.pageList.pageNo,
          pageSize: that.pageList.pageSize,
          memberName: that.name,
        };
        let res = await getMoneBackList(params);
        if (res.success) {
          this.list_data = res.result.records;
          this.pageList = res.result;
        } else {
          that.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },

  created() {
    this.readyPatientList();
  },
  mounted() {},
  computed: {
    commentImgArr() {
      //图片字符串分割数组,utils内的方法
      return utils.commentImgList(this.commentInfo.accessory);
    },
    // evaluateBtnShow() {  //控制是否展示查看评价按钮
    //   if (this.commentInfo) {
    //     return true
    //   }else {
    //     return false
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__empty-text {
  color: #cfcbc9 !important;
  font-weight: bold;
  font-size: 18px;
  padding-top: 200px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-repeat: no-repeat;
  background-position: center !important;
}

.headImg {
  width: 100px;
  height: 100px;
}

/deep/ .el-table__empty-text span {
  position: relative;
  right: 10px !important;
}

/deep/ .el-dialog--center {
  width: 60% !important;
  // box-shadow: none !important;
}

/deep/ .el-dialog__body {
  margin: 0 10% !important;
}

.assess-button {
  background: #f56c6c !important;
  border-color: #f56c6c !important;
}
.assess-dialog-userInfo {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.operat-button {
  margin: 5px 0 0 10px !important;
}

.dialog-span-two {
  margin-top: 30px;
  .dialog-span-header {
    font-size: 17px;
    color: #000000;
    border-left: 4px solid #fc701a;
    padding-left: 5px;
  }
  .dialog-span-main {
    font-size: 17px;
    line-height: 30px;
    color: #000000;
    margin: 0 5px 0 35px;
    .annex-img {
      width: 100px;
      height: 100px;
      margin-right: 5px;
      padding-top: 10px;
      cursor: pointer;
    }
  }
  .demo-image__preview {
    margin: 0 !important;
  }
}

.dialog-span {
  display: inline-block;
  margin-top: 20px;
  .dialog-span-header {
    font-size: 17px;
    color: #000000;
    border-left: 4px solid #fc701a;
    padding-left: 5px;
  }
  .dialog-span-header-two {
    flex: 1;
    font-size: 17px;
    color: #000000;
  }
  .dialog-span-header-three {
    flex: 1;
    font-size: 17px;
    padding: 0 10px;
    color: #000000;
  }
  .dialog-span-main {
    font-size: 17px;
    color: #000000;
    margin-top: 25px;
    margin-right: 35px;
    margin-left: 35px;
  }
}

.el-button--info {
  background: #67c23a;
  border-color: #67c23a;
}

.el-button--danger {
  background: #fc701a;
  border-color: #fc701a;
}

.patient-list {
  display: flex;
  width: 100%;
  padding: 20px;
  // .main {
  //   display: flex;
  // }
  .listWarpper {
    width: 98%;
    .box-card {
      width: 98%;
    }
  }
  .mainItem {
    float: left;
    width: 38%;
  }

  .mainItem:nth-child(2) {
    margin: 0 20px;
    width: 38%;
  }

  .mainItem:nth-child(3) {
    width: 18%;
    display: flex;
    justify-content: space-around;
  }

  .pageWarpper {
    text-align: center;
  }

  .searchInput_btn {
    margin-left: 40px;
    height: 40px;
    width: 100px;
  }
}
</style>
